<template>
  <div v-if="book">
    <AppLink :to="`/bubble/${book.uuid}`">
      <div class="border rounded-lg p-6 bg-card cursor-pointer">
        <div class="flex items-start mb-4">
          <NuxtImg
            v-if="
              book.meta?.offlineMediaResources?.cover_photo ||
              book.smallThumbnail ||
              book.coverPhoto
            "
            :src="
              book.meta?.offlineMediaResources?.cover_photo ||
              book.smallThumbnail ||
              book.coverPhoto ||
              undefined
            "
            :alt="book.title"
            class="w-24 h-auto object-cover rounded mr-6 aspect-[2/3] flex-shrink-0"
            loading="lazy"
            width="96"
            :height="144"
          />
          <div class="flex-grow">
            <h3 class="text-xl font-semibold mb-2">{{ book.title }}</h3>
            <p class="text-muted-foreground mb-2">
              {{ book.authors?.join(', ') || 'Unknown Author' }}
            </p>
            <p class="text-sm text-muted-foreground">{{ book.categories?.join(', ') }}</p>
          </div>
        </div>
        <p
          class="text-muted-foreground mb-4 prose dark:prose-invert"
          v-html="sanitizedDescription"
        ></p>
        <Button variant="default" class="hover:opacity-90" @click.stop="$emit('refresh')">
          Get Another Suggestion
        </Button>
      </div>
    </AppLink>
  </div>
</template>

<script setup lang="ts">
import type { BookBubble } from '~/stores/interfaces'
import { Button } from '@/components/ui/button'
import AppLink from '@/components/ui/link/AppLink.vue'
import DOMPurify from 'isomorphic-dompurify'
import { computed } from 'vue'

const props = defineProps<{
  book: BookBubble | null
}>()

defineEmits<{
  (e: 'refresh'): void
}>()

function truncateDescription(description: string): string {
  return description.length > 150 ? description.slice(0, 150) + '...' : description
}

const sanitizedDescription = computed(() => {
  if (!props.book?.description) return ''
  const truncated = truncateDescription(props.book.description)
  return DOMPurify.sanitize(truncated, {
    ALLOWED_TAGS: ['b', 'i', 'em', 'strong', 'a', 'p', 'br'],
    ALLOWED_ATTR: ['href', 'target', 'rel'],
    ALLOW_DATA_ATTR: false,
  })
})
</script>
